exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type=\"tel\"] {\n\tfont-family: \"Courier New\", Courier, monospace;\n}\n", ""]);

// exports
